import { render } from "./SaveableColumnForm.vue?vue&type=template&id=5fcb8e9b&scoped=true&ts=true"
import script from "./SaveableColumnForm.vue?vue&type=script&lang=ts"
export * from "./SaveableColumnForm.vue?vue&type=script&lang=ts"

import "./SaveableColumnForm.vue?vue&type=style&index=0&id=5fcb8e9b&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/Momentum/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fcb8e9b"]])

export default __exports__